module.exports = "/_next/static/images/14day-99e6a11cd4a0daf60d34c14233412d3a.png";